import $ from 'jquery';
import constants from 'Constants.js';
import { View } from 'backbone';
import { Model } from 'backbone';
import BaseTableView from 'properties/BaseTableView.js'
import listService      from 'ListService.js';
import undoService      from 'UndoService.js';
import Template from 'behaviors/properties/main/copy-fields.ejs';
import selectFieldModalView from 'common-views/SelectFieldModalView.js';
import widgetUtil from 'util/WidgetUtil.js';
import eventBus from 'EventBus.js';
import util from 'util/Util.js';
import textConstants from "../../../../constants/TextConstants";

//=====================================================================
//
// An instance of this view represents a copy fields.
//
// Casey Justus, May 16, 2016
//
//=====================================================================

class MainCopyFields extends BaseTableView {


    initialize( opts ) {
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.gridEl = constants.PROP_MAIN_TABLE;

        this.events = {
            "click .itemNew"                : "itemNew",
            "click .itemRemove"             : "itemRemove",
            "click .field-select"           : "selectField"
        };

        this.loadDataFromProperty();
        this.initGridData();

        if (!util.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
            this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, util.resizeGridWidth);
        }

        return this;
    }

    loadDataFromProperty() {
        const prop = this.model.get('Property');
        const fieldsTo = _.find(prop, function(obj) { return obj._id === 'fieldsTo' });
        const fieldsFrom = _.find(prop, function(obj) { return obj._id === 'fieldsFrom' });

        if (!fieldsFrom.Item) { fieldsFrom.Item = []; }
        if (!fieldsTo.Item) { fieldsTo.Item = []; }

        let dataFromFields = this.getDataFields(fieldsFrom);
        let dataToFields = this.getDataFields(fieldsTo);

        this.model.set('fromFields', dataFromFields, {silent:true});
        this.model.set('toFields', dataToFields, {silent:true});

    }

    getDataFields(fields){
        let dataFields = [];
        let cid = '';
        let name = '';
        let id;
        if (Array.isArray(fields.Item)) {
            for (var i = 0; i < fields.Item.length; i++) {
                id = fields.Item[i]._value;
                name =listService.determineFieldName(id);
                cid =id;

                dataFields.push({name: name, id: cid, row: i});
            }
        } else {
            id = fields.Item._value;
            let obj;
            if (id.includes('$')) {
                name =listService.determineFieldName(id);
                cid = id;
            }else{
                obj = listService.getObject(listService.cleanId(id));
                name = obj ? obj.model.get('name') : '';
                cid = obj ? obj.model.get('id') : '';
            }
            const newItem = {_value: fields.Item._value};
            fields.Item = [newItem];

            dataFields.push({name: name, id: cid, row: 0});
        }
        return dataFields;
    }

    initGridData(){
        this.model.set({
            colModel: [
                {
                    name: 'from',
                    index: 'from',
                    width: 45,
                    editable: false,
                    formatter: function(cellValue){
                        return cellValue.name;
                    }
                },
                {
                    name: 'test',
                    index: 'test',
                    width: 20,
                    formatter: function(cellValue, options, rowObject){
                        let result = '';
                        if ( rowObject.from.row !== '' ) {
                            const rowId = rowObject.row;
                            result = `<button class="field-select copy-fields" data-target-row="${rowId}" data-target-col="from">...</button>`;
                        }
                        return result;
                    }
                },
                {
                    name: 'to',
                    index: 'to',
                    width: 45,
                    editable: false,
                    formatter: function(colValue){ return colValue.name}
                },
                {
                    name: 'test2',
                    index: 'test',
                    width: 20,
                    formatter: function(cellValue, options, rowObject){
                        let result = '';
                        if ( rowObject.to.row !== '' ) {
                            const rowId = rowObject.row;
                            result = `<button class="field-select copy-fields" data-target-row="${rowId}" data-target-col="to">...</button>`;
                        }
                        return result;
                    }
                }

            ],
            colNames: ['From', '', 'To', '']
        }, {silent: true});
        this.fillGridData();
    }

    fillGridData(){
        let
            fromFields = this.model.get('fromFields'),
            toFields = this.model.get('toFields'),
            rowNumber = (fromFields.length > toFields.length) ? fromFields.length : toFields.length,
            gridData = [];
        
        for(var i = 0; i < rowNumber; i++){
            /**
             * There is no way to guarantee we will always have even arrays, so we check and if there is no
             * object in one of the arrays we set a default one
             */
            fromFields[i] = fromFields[i] || {name:'', row:i};
            toFields[i] = toFields[i] || {name:'', row:i};

            gridData.push({'from':fromFields[i], 'to':toFields[i], 'row':i});
        }

        for (let i=gridData.length; i<5; ++i){
            let empty = {name:'', row: ''};
            gridData.push({'from':empty, 'to':empty, 'row':i});
        }

        this.model.set('gridData', gridData, {silent: true});
    }

    selectField(e){
        const
            target = e.currentTarget,
            targetRow = parseInt(target.getAttribute('data-target-row')),
            targetCol = target.getAttribute('data-target-col');

        var sfModel = new Model();
        sfModel.set("dataSelectedItemId", this.model.attributes.gridData[targetRow][targetCol].id, {silent:true});
        
        var sfModal = new selectFieldModalView({model: sfModel, mode: 'objects'});
        sfModal.render().then((selectedField)=>{

            let fieldsTo = _.find(this.model.attributes.Property, function(obj) { return obj._id === 'fieldsTo' });
            let fieldsFrom = _.find(this.model.attributes.Property, function(obj) { return obj._id === 'fieldsFrom' });


            if(targetCol === 'from'){
                let fromRows = this.model.get('fromFields');
                fromRows[targetRow] = selectedField;
                this.model.set('fromRows', fromRows, {silent: true});
                fieldsFrom.Item[targetRow] = { _value: selectedField.id };
            } else {
                let toRows = this.model.get('toFields');
                toRows[targetRow] = selectedField;
                this.model.set('toRows', toRows, {silent: true});
                fieldsTo.Item[targetRow] = { _value: selectedField.id };
            }

            this.fillGridData();
            this.model.trigger("loadRelatedFields");
            this.render();

        }).catch(err => console.log(err));

    }

    itemNew(){
        this.model.set('newRowAdded', true, constants.MODEL_SILENT);
        util.saveGridScrollPos(this.model);
        let rawGridData = this.model.get('gridData');
        let oldGridData = [...this.model.get('gridData') || []];
        let oldFromFields = [...this.model.get('fromFields') || []];
        let oldFromRows = [...this.model.get('fromRows') || []];
        let oldToRows = [...this.model.get('toRows') || []];
        let oldToFields = [...this.model.get('toFields')];
        let oldFieldsToProperty= [..._.find(this.model.attributes.Property, function(obj) { return obj._id === 'fieldsTo' }).Item];
        let oldFieldsFromProperty = [..._.find(this.model.attributes.Property, function(obj) { return obj._id === 'fieldsFrom' }).Item];
        let gridData = [];

        for (let i = 0; i<rawGridData.length; ++i){
            if (rawGridData[i].from.name !=='' || rawGridData[i].from.row !=='' ||
                rawGridData[i].to.name !=='' || rawGridData[i].to.row !=='') {
                gridData.push(rawGridData[i]);
            }
        }

        const
            rowCount = gridData.length,
            lastRow = gridData[rowCount - 1];

        let
            fromFields = this.model.get('fromFields'),
            toFields = this.model.get('toFields');
        fromFields[rowCount] = {'name': '', row: rowCount};
        toFields[rowCount] = {'name': '', row: rowCount};

        this.model.set('fromRows', gridData, {silent: true});
        this.model.set('toRows', gridData, {silent: true});

        let fieldsTo = _.find(this.model.attributes.Property, function(obj) { return obj._id === 'fieldsTo' });
        let fieldsFrom = _.find(this.model.attributes.Property, function(obj) { return obj._id === 'fieldsFrom' });

        fieldsTo.Item.push({ _value: '' } );
        fieldsFrom.Item.push({ _value: '' } );


        this.initGridData();
        this.model.set('widgetText', widgetUtil.getWidgetText(this.model),{silent:true} ) ;
        this.model.trigger('widgetTextUpdated');
        this.render();

        let updatedGridData = [...this.model.get('gridData')];
        let updatedFromFields = [...this.model.get('fromFields')];
        let updatedToFields = [...this.model.get('toFields')];
        let updatedFromRows = [...this.model.get('fromRows')];
        let updatedToRows = [...this.model.get('toRows')];
        let updatedFieldsTo = [..._.find(this.model.attributes.Property, function(obj) { return obj._id === 'fieldsTo' }).Item];
        let updatedFieldsFrom = [..._.find(this.model.attributes.Property, function(obj) { return obj._id === 'fieldsFrom' }).Item];



        undoService.add({
            undo:()=>{
                this.model.set('gridData', oldGridData, {silent: true});
                this.model.set('fromFields', oldFromFields, {silent: true});
                this.model.set('toFields', oldToFields, {silent: true});
                this.model.set('fromRows', oldFromRows, {silent: true});
                this.model.set('toRows', oldToRows, {silent: true});
                let fieldsTo = _.find(this.model.attributes.Property, function(obj) { return obj._id === 'fieldsTo' });
                let fieldsFrom = _.find(this.model.attributes.Property, function(obj) { return obj._id === 'fieldsFrom' });
                fieldsTo.Item = oldFieldsToProperty;
                fieldsFrom.Item = oldFieldsFromProperty;

                this.initGridData();
                this.model.set('widgetText', widgetUtil.getWidgetText(this.model),{silent:true}) ;
                this.model.trigger('widgetTextUpdated');
                this.render();
            },
            redo:() => {
                this.model.set('gridData', updatedGridData, {silent: true});
                this.model.set('fromFields', updatedFromFields, {silent: true});
                this.model.set('toFields', updatedToFields, {silent: true});
                this.model.set('fromRows', updatedFromRows, {silent: true});
                this.model.set('toRows', updatedToRows, {silent: true});

                let fieldsTo = _.find(this.model.attributes.Property, function(obj) { return obj._id === 'fieldsTo' });
                let fieldsFrom = _.find(this.model.attributes.Property, function(obj) { return obj._id === 'fieldsFrom' });
                fieldsTo.Item = updatedFieldsTo;
                fieldsFrom.Item = updatedFieldsFrom;

                this.initGridData();
                this.model.set('widgetText', widgetUtil.getWidgetText(this.model),{silent:true}) ;
                this.model.trigger('widgetTextUpdated');
                this.render();
            }
        },textConstants.UNDO_PROP_CHANGE);
    }

    itemRemove(){
        util.saveGridScrollPos(this.model);
        const rowid = this.model.get('rowid');
        let gridData = this.model.get('gridData');

        if(rowid){ //If there is a row selected
            if (gridData[rowid].from.row !=='' && gridData[rowid].to.row !== '') {
                const prop = this.model.get('Property');
                let fieldsTo = _.find(prop, function(obj) { return obj._id === 'fieldsTo' });
                let fieldsFrom = _.find(prop, function(obj) { return obj._id === 'fieldsFrom' });

                fieldsTo.Item.splice(rowid,1);
                fieldsFrom.Item.splice(rowid,1);

                super.itemRemove();

                this.loadDataFromProperty();
                this.initGridData();
                this.model.set('widgetText', widgetUtil.getWidgetText(this.model) ) ;

                this.render();
            }
        }
    }
}

export default MainCopyFields;
